import React from 'react'

function LoginStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .wrapper {
          display: flex;
          /*border: solid 1px black;*/
          position: absolute;
          left: 20%;
          top: 15%;
          box-sizing: border-box;
          width: 60vw;
          height: 72vh;
          justify-content: center;

          border-radius: 10px;
          background-color: white;
          box-shadow: 1px 1px 3px 1px #AAA;
        }

        .npos-login-header {
          padding-bottom: 10px;
          font-size: 1.2rem;
          font-weight: bold;
        }

        .left-container {
          flex: 1;
          display: flex;
          justify-content: center;
          /*background: linear-gradient(to right, rgba(32, 50, 80, 0.2), rgba(255, 255, 255, 1));*/
          background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(255, 255, 255, 1));
          background-size: cover; 
          border-radius: 10px 0 0 10px;
        }
        .right-container {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }

        .logo-container {
          margin: auto;
          text-align: center;
        }

        .login-container {
          display: flex;
          width: 100%;
          heigt: 100vh;
          padding: 30px;
          /*border: solid 0.5px green;*/
          border-radius: 0 10px 10px 0;
          background-color: white;
          justify-content: center;
          /*box-shadow: 1px 1px 3px 1px #AAA;*/
          /*box-sizing: border-box;*/
          /*border-left: solid 1px grey;*/

          /*
          margin: auto;
          */
          /*
          position: absolute;
          top: 50%;
          */

          /*
          left: 50%;
          position: absolute;
          top: 50%;
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
          */
        }

        .login-form {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .login-form input {
          padding: 15px;
          margin: 10px;
          font-size: 1em;
        }

        .login-form .pospro-action-btn {
          margin: 10px;
          border: solid 0.2px green;
          padding: 20px;
          font-weight: bold;
          /*
          border-radius: 15px;
          align-self: center;
          width: 70%;
          */
        }

        .login-form .linked-button {
          margin-top: 10px;
        }

        .error-container {
          font-size: 0.9rem;
          color: red;
          border: solid 0.5px red;
          padding: 10px;
          margin: 10px;
          background-color: black;
          text-align: center;
        }

        #loading-container { 
          display: flex;
          margin: auto;
        }

        /*
        .loading-container {
          font-size: 0.9rem;
          color: green;
          border: solid 0.5px green;
          padding: 10px;
          margin: 10px;
          background-color: white;
          text-align: center;
        }
        */

        .hide { display: none; }

      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(LoginStyle)
